import { FC } from 'react';
import { RiCheckFill } from 'react-icons/ri';

export const CalculateTimepointCell: FC<{ value: boolean }> = ({ value }) =>
  value ? (
    <RiCheckFill data-test-component="CalculateTimepointCell" data-test-element="check" />
  ) : (
    <div data-test-component="CalculateTimepointCell" data-test-element="empty"></div>
  );
